/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigStatus,
  GetGtaRateList200Response,
  GtaRate,
  SortGtaRequest,
  StoreGtaRequest,
  UpdateGtaRequest,
} from '../models/index';
import {
    ConfigStatusFromJSON,
    ConfigStatusToJSON,
    GetGtaRateList200ResponseFromJSON,
    GetGtaRateList200ResponseToJSON,
    GtaRateFromJSON,
    GtaRateToJSON,
    SortGtaRequestFromJSON,
    SortGtaRequestToJSON,
    StoreGtaRequestFromJSON,
    StoreGtaRequestToJSON,
    UpdateGtaRequestFromJSON,
    UpdateGtaRequestToJSON,
} from '../models/index';

export interface CreateGtaRateRequest {
    StoreGtaRequest: StoreGtaRequest;
}

export interface GetGtaRateRequest {
    gta_id: string;
}

export interface GetGtaRateListRequest {
    client_id?: number;
    page?: number;
    per_page?: number;
    search?: string;
    status?: ConfigStatus;
}

export interface SortGtaRateRequest {
    gta_id: string;
    SortGtaRequest: SortGtaRequest;
}

export interface UpdateGtaRateRequest {
    gta_id: string;
    UpdateGtaRequest: UpdateGtaRequest;
}

export interface UploadGtaConfigRequest {
    file: Blob | null;
}

/**
 * 
 */
export class GtaRatesApi extends runtime.BaseAPI {

    /**
     * Create GtaRate
     */
    async createGtaRateRaw(requestParameters: CreateGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GtaRate>> {
        if (requestParameters['StoreGtaRequest'] == null) {
            throw new runtime.RequiredError(
                'StoreGtaRequest',
                'Required parameter "StoreGtaRequest" was null or undefined when calling createGtaRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gta`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StoreGtaRequestToJSON(requestParameters['StoreGtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GtaRateFromJSON(jsonValue));
    }

    /**
     * Create GtaRate
     */
    async createGtaRate(requestParameters: CreateGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GtaRate> {
        const response = await this.createGtaRateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get GTA Config
     */
    async getGtaConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gta/download-config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get GTA Config
     */
    async getGtaConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getGtaConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     * get GtaRate
     */
    async getGtaRateRaw(requestParameters: GetGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GtaRate>> {
        if (requestParameters['gta_id'] == null) {
            throw new runtime.RequiredError(
                'gta_id',
                'Required parameter "gta_id" was null or undefined when calling getGtaRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gta/{gta_id}`.replace(`{${"gta_id"}}`, encodeURIComponent(String(requestParameters['gta_id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GtaRateFromJSON(jsonValue));
    }

    /**
     * get GtaRate
     */
    async getGtaRate(requestParameters: GetGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GtaRate> {
        const response = await this.getGtaRateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get GtaRate List
     */
    async getGtaRateListRaw(requestParameters: GetGtaRateListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGtaRateList200Response>> {
        const queryParameters: any = {};

        if (requestParameters['client_id'] != null) {
            queryParameters['client_id'] = requestParameters['client_id'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['per_page'] != null) {
            queryParameters['per_page'] = requestParameters['per_page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gta`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGtaRateList200ResponseFromJSON(jsonValue));
    }

    /**
     * Get GtaRate List
     */
    async getGtaRateList(requestParameters: GetGtaRateListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGtaRateList200Response> {
        const response = await this.getGtaRateListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sort GtaRate
     */
    async sortGtaRateRaw(requestParameters: SortGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GtaRate>> {
        if (requestParameters['gta_id'] == null) {
            throw new runtime.RequiredError(
                'gta_id',
                'Required parameter "gta_id" was null or undefined when calling sortGtaRate().'
            );
        }

        if (requestParameters['SortGtaRequest'] == null) {
            throw new runtime.RequiredError(
                'SortGtaRequest',
                'Required parameter "SortGtaRequest" was null or undefined when calling sortGtaRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gta/{gta_id}/sort`.replace(`{${"gta_id"}}`, encodeURIComponent(String(requestParameters['gta_id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SortGtaRequestToJSON(requestParameters['SortGtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GtaRateFromJSON(jsonValue));
    }

    /**
     * Sort GtaRate
     */
    async sortGtaRate(requestParameters: SortGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GtaRate> {
        const response = await this.sortGtaRateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update GtaRate
     */
    async updateGtaRateRaw(requestParameters: UpdateGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GtaRate>> {
        if (requestParameters['gta_id'] == null) {
            throw new runtime.RequiredError(
                'gta_id',
                'Required parameter "gta_id" was null or undefined when calling updateGtaRate().'
            );
        }

        if (requestParameters['UpdateGtaRequest'] == null) {
            throw new runtime.RequiredError(
                'UpdateGtaRequest',
                'Required parameter "UpdateGtaRequest" was null or undefined when calling updateGtaRate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/gta/{gta_id}`.replace(`{${"gta_id"}}`, encodeURIComponent(String(requestParameters['gta_id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGtaRequestToJSON(requestParameters['UpdateGtaRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GtaRateFromJSON(jsonValue));
    }

    /**
     * Update GtaRate
     */
    async updateGtaRate(requestParameters: UpdateGtaRateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GtaRate> {
        const response = await this.updateGtaRateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload GTA Config
     */
    async uploadGtaConfigRaw(requestParameters: UploadGtaConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadGtaConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/gta/upload-config`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload GTA Config
     */
    async uploadGtaConfig(requestParameters: UploadGtaConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadGtaConfigRaw(requestParameters, initOverrides);
    }

}
